import { useMutation } from 'react-query';
import { isUndefined } from 'utils/tsHelpers';
import { ApiResponse } from 'services/api';

import { useRestMutation } from 'utils/hooks/api/useRestMutation';
import { setParams } from 'utils/urlParams';
import { createLazyRestRequest } from 'utils/hooks/api';

import { List } from '../types';

const DELETE_LIST_ENDPOINT = '/lists/delete';

const createDeleteParams = (list: List | null) =>
  setParams(DELETE_LIST_ENDPOINT, { emailListId: list?.id?.toString() ?? '' });

export const useDeleteListMutation = (list: List | null) => {
  const { mutate, isSuccess, isError, isLoading, error } = useRestMutation(
    createDeleteParams(list),
  );

  const deleteList = () => {
    if (list) mutate({});
  };

  return { deleteList, isSuccess, isError, isLoading, error };
};

export const useLazyDeleteListMutation = () => {
  const { mutateAsync, ...rest } = useMutation(
    createLazyRestRequest({ url: DELETE_LIST_ENDPOINT }),
  );
  const deleteListAsync = (vars: { list: Partial<List> }): Promise<ApiResponse> => {
    if (isUndefined(vars?.list?.id)) {
      return mutateAsync({});
    }

    return mutateAsync({
      requestConfig: { url: createDeleteParams(vars.list as List) },
    });
  };
  return {
    ...rest,
    deleteListAsync,
  };
};
